import buildUrl from 'build-url';
import { API_URL } from './constants';

export const buildApiUrl = (path, opts) => (
    buildUrl(`${API_URL}${path}`, opts)
);
